import React from 'react';
import { Card } from '@material-ui/core';
import CreatePayoffFrom from './CreatePayoffFrom';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    padding: 50,
  },
}));

const CreatePayeoff = () => {
  const classes = useStyles();

  const { currentPayoff } = useSelector(({ finance }) => finance);

  return (
    <PageContainer heading={currentPayoff ? `تسویه حساب ${currentPayoff?.user?.fullname}` : 'تسویه حساب جدید'}>
      <Card className={classes.cardRoot}>
        <CreatePayoffFrom payoff={currentPayoff} />
      </Card>
    </PageContainer>
  );
};

export default CreatePayeoff;
